module.exports = __webpack_public_path__ + "media/components/app-store/static/s8-c04995b45cfbf27e22f5bccabd1ce80a.png";